import { render, staticRenderFns } from "./PayMe.vue?vue&type=template&id=2c1c5570&scoped=true"
import script from "./PayMe.vue?vue&type=script&lang=js"
export * from "./PayMe.vue?vue&type=script&lang=js"
import style0 from "./PayMe.vue?vue&type=style&index=0&id=2c1c5570&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1c5570",
  null
  
)

export default component.exports